export { default } from './PatientDemographics';
